import { apiFetch } from './client'
import type { ServiceCreate, ServiceRead, ServiceUpdate } from '../types/service'

export async function listServices(params: {
  practice_id: number
  include_inactive?: boolean
}): Promise<ServiceRead[]> {
  const qs = new URLSearchParams({ practice_id: String(params.practice_id) })
  if (params.include_inactive !== undefined) qs.set('include_inactive', String(params.include_inactive))
  const res = await apiFetch(`/api/services?${qs}`)
  if (!res.ok) throw new Error('Failed to load services')
  return res.json() as Promise<ServiceRead[]>
}

export async function createService(data: ServiceCreate): Promise<ServiceRead> {
  const res = await apiFetch('/api/services', {
    method: 'POST',
    body: JSON.stringify(data),
  })
  if (!res.ok) {
    const err = (await res.json()) as { detail?: string }
    throw new Error(typeof err.detail === 'string' ? err.detail : 'Failed to create service')
  }
  return res.json() as Promise<ServiceRead>
}

export async function updateService(id: number, data: ServiceUpdate): Promise<ServiceRead> {
  const res = await apiFetch(`/api/services/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  })
  if (!res.ok) {
    const err = (await res.json()) as { detail?: string }
    throw new Error(typeof err.detail === 'string' ? err.detail : 'Failed to update service')
  }
  return res.json() as Promise<ServiceRead>
}
